import { render, staticRenderFns } from "./CtsDetail.vue?vue&type=template&id=8767cf94&scoped=true"
import script from "./CtsDetail.vue?vue&type=script&lang=js"
export * from "./CtsDetail.vue?vue&type=script&lang=js"
import style0 from "./CtsDetail.vue?vue&type=style&index=0&id=8767cf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8767cf94",
  null
  
)

export default component.exports